<template>
  <ModalSimpleAlertWithDismiss
    @confirm="submit"
    @close="emit('close')"
    :show="props.show"
    title="Delete Comment"
    :processing="form.processing"
    description="Please confirm you would like to delete this comment."
  />
</template>

<script setup>
import ModalSimpleAlertWithDismiss from '@/Common/Overlays/Modals/ModalSimpleAlertWithDismiss.vue'
import { useForm } from '@inertiajs/inertia-vue3'

const props = defineProps({
  show: Boolean,
  comment: Object,
  routeName: String,
})

const form = useForm({})

const emit = defineEmits(['close', 'success'])

function submit() {
  form.delete(route(props.routeName, props.comment), {
    preserveScroll: true,
    preserveState: true,
    onSuccess: () => {
      emit('success')
      emit('close')
    },
  })
}
</script>
